import React, { useState, useEffect } from "react";
import AboutMe from "../AboutMe";
import ContactMe from "../ContactMe";
import Footer from "../Footer";
import HeroSection from "../HeroSection";
import MyPortfolio from "../MyPortfolio";
import Testimonial from "../Testimonials";
import WaveDesign from "../WaveDesign";

const SparklingStars = () => {
  const [stars, setStars] = useState([]);

  useEffect(() => {
    const numberOfStars = 50;
    const initialStars = Array.from({ length: numberOfStars }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: Math.random() < 0.5 ? "w-1 h-1" : "w-2 h-2",
      delay: `${Math.random() * 2000}ms`,
    }));
    setStars(initialStars);
  }, []);

  return (
    <div className="fixed inset-0 z-0">
      {stars.map((star) => (
        <div
          key={star.id}
          className={`absolute ${star.size} bg-yellow-200 rounded-full animate-pulse`}
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            animationDelay: star.delay,
            animationDuration: "1.5s",
          }}
        />
      ))}
    </div>
  );
};

const Home = () => {
  return (
    <div className="relative min-h-screen">
      <SparklingStars />
      <div className="relative z-10">
        <HeroSection />
        <WaveDesign />
        <MyPortfolio />
        <AboutMe />
        <Testimonial />
        <ContactMe />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
